import { faBadgeCheck, faUniversity } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observer } from 'mobx-react-lite';
import React from 'react';

import type { IBankAccountSource } from '@feathr/blackbox';
import type { Billable } from '@feathr/blackbox';

import PaymentMethod from '../PaymentMethod';
import BankAccountVerify from './BankAccountVerify/index';

import * as styles from './BankAccount.css';

interface IProps {
  billable: Billable;
}

function BankAccount({ billable }: IProps) {
  const source = !billable.isPending
    ? (billable.get('stripe').source as IBankAccountSource | undefined)
    : undefined;
  if (source === undefined) {
    return null;
  }

  return (
    <>
      <PaymentMethod
        icon={<FontAwesomeIcon icon={faUniversity} size={'3x'} />}
        label={
          <>
            ACH account ending in {source.last4}
            {source.status === 'verified' && (
              <FontAwesomeIcon className={styles.verified} icon={faBadgeCheck} />
            )}
          </>
        }
      />
      {!['verified', 'errored'].includes(source.status) && (
        <BankAccountVerify billable={billable} />
      )}
    </>
  );
}

export default observer(BankAccount);
